import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Layout, BackButton, Navigation, LayoutContent } from '../../../components';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { StatsRow } from './StatsRow';
import { LocationStatsRow } from './LocationStatsRow';
import { LiveDeliveryStatsQuery, LiveDeliveryStatsQueryVariables } from './__generated__/LiveDeliveryStatsQuery';
import './LiveStats.scss';

interface LiveDeliveryStatsRouterParams {
  venueId: string;
  fulfillmentCenterId: string;
  parentId: string;
}

type RouterProps = RouteComponentProps<LiveDeliveryStatsRouterParams>;

interface LiveDeliveryStatsProps extends RouterProps {
  loading: boolean;
  data?: LiveDeliveryStatsQuery;
}

const LiveDeliveryStatsUnwrapped = (props: LiveDeliveryStatsProps) => {
  const { loading, data } = props;

  const onClickBack = React.useCallback(() => {
    props.history.goBack();
  }, [props.history]);

  const { fulfillmentCenter, liveStats } = data;
  const { venueId, fulfillmentCenterId } = props.match.params;
  if (loading) {
    return <div>'Loading...'</div>;
  }

  return (
    <div>
      <div className='delivery-location-live-stats-header'>
        <BackButton onClick={onClickBack} />
        <h2 className='text-center'>{fulfillmentCenter.name}</h2>
      </div>
      <StatsRow {...liveStats.totalStats} />
      {liveStats.locations.map((location) => (
        <LocationStatsRow venueId={venueId} fulfillmentCenterId={fulfillmentCenterId} key={location.id} {...location} />
      ))}
    </div>
  );
};

const query = gql`
  query LiveDeliveryStatsQuery($venueId: ID!, $fulfillmentCenterId: ID!, $parentLocationId: ID) {
    fulfillmentCenter(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId) {
      id
      name
    }
    liveStats(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId, parentLocationId: $parentLocationId) {
      totalStats {
        ...LiveStatsField
      }
      locations {
        id
        name
        stats {
          ...LiveStatsField
        }
      }
    }
  }

  fragment LiveStatsField on LiveStats {
    orders
    sales
    tips
    averageTipPercentage
  }
`;

export const LiveDeliveryStats = (props: RouterProps) => {
  const { venueId, fulfillmentCenterId, parentId } = props.match.params;
  const { loading, error, data } = useQuery<LiveDeliveryStatsQuery, LiveDeliveryStatsQueryVariables>(query, {
    variables: {
      venueId,
      fulfillmentCenterId,
      parentLocationId: parentId,
    },
  });

  return (
    <Layout>
      <Navigation />
      <Layout.TopBar>
        <Layout.TopBar.Left>
          <Layout.TopBar.Title>Fulfillment Stations</Layout.TopBar.Title>
        </Layout.TopBar.Left>
      </Layout.TopBar>
      <LayoutContent error={error}>
        <LiveDeliveryStatsUnwrapped {...props} loading={loading} data={data} />
      </LayoutContent>
    </Layout>
  );
};
